// PDF Design settings: what to include / exclude when rendering a quotation.

export type DetailsStyle = 'Closed Book' | 'Transparent' | 'Open Book';
export type TimingStyle = 'Closed Book' | 'Transparent' | 'Open Book';

export interface PdfDesign {
  style: DetailsStyle;
  basics: {
    includeCompanyLogo: boolean;
    includeCustomerLogo: boolean;
    includePartsIcon: boolean;
    includeProcessesPerPart: boolean;
    timingStyle: TimingStyle;
    includeGantt: boolean;
  };
  equipment: {
    includeEquipmentIcons: boolean;
    includeAccessories: boolean;
    includeEquipmentConsumables: boolean;
  };
  technicians: {
    includeNames: boolean;
  };
  consumables: {
    includeConsumables: boolean;
  };
  markups: {
    includeMarkups: boolean;
    includeMarkupsForEach: boolean;
  };
}

export function presetDesign(style: DetailsStyle): PdfDesign {
  if (style === 'Closed Book') {
    return {
      style,
      basics: {
        includeCompanyLogo: true,
        includeCustomerLogo: true,
        includePartsIcon: true,
        includeProcessesPerPart: false,
        timingStyle: 'Closed Book',
        includeGantt: false,
      },
      equipment: {
        includeEquipmentIcons: true,
        includeAccessories: false,
        includeEquipmentConsumables: false,
      },
      technicians: { includeNames: false },
      consumables: { includeConsumables: false },
      markups: { includeMarkups: false, includeMarkupsForEach: false },
    };
  }
  if (style === 'Transparent') {
    return {
      style,
      basics: {
        includeCompanyLogo: true,
        includeCustomerLogo: true,
        includePartsIcon: true,
        includeProcessesPerPart: true,
        timingStyle: 'Transparent',
        includeGantt: false,
      },
      equipment: {
        includeEquipmentIcons: true,
        includeAccessories: true,
        includeEquipmentConsumables: true,
      },
      technicians: { includeNames: false },
      consumables: { includeConsumables: true },
      markups: { includeMarkups: false, includeMarkupsForEach: false },
    };
  }
  // Open Book
  return {
    style,
    basics: {
      includeCompanyLogo: true,
      includeCustomerLogo: true,
      includePartsIcon: true,
      includeProcessesPerPart: true,
      timingStyle: 'Open Book',
      includeGantt: false,
    },
    equipment: {
      includeEquipmentIcons: true,
      includeAccessories: true,
      includeEquipmentConsumables: true,
    },
    technicians: { includeNames: false },
    consumables: { includeConsumables: true },
    markups: { includeMarkups: true, includeMarkupsForEach: false },
  };
}
